import { IUserResource } from "../users/IUserResource";

export const getUserDisplayName = (user: IUserResource) => {
    if (!user.name || !user.surname) {
        return user.email;
    }

    return `${user.name} ${user.surname}`;
};
